<template>
	<div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-8'">
    <v-row>
      <v-col cols="12" md="3">
        <v-card
          flat
          elevation="5"
          width="210"
          class="pa-0 mx-auto">
          <v-img 
            contain
            :src="user.userUrlImg"
            :gradient="showPage && selectedPage === 'form' ? 'to top, rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.50)' : ''"
            width="210"
            height="210"
            class="mx-auto d-flex text-center align-center"
            v-if="!showPage || (showPage && selectedPage !== 'form')">
            <v-icon v-if="showPage && selectedPage === 'form'" color="#fff" large>mdi-camera</v-icon>
          </v-img>
        </v-card>
        <v-card
          flat
          width="210"
          class="pa-0 mx-auto"
          style="background: transparent;"
          v-if="showPage && selectedPage === 'form'">
          <image-input v-model="avatar">
            <div slot="activator">
              <v-avatar 
                width="210"
                height="210"
                class="c-p"
                v-ripple 
                tile>
                <v-img 
                  contain
                  :src="form.profileUrlImage"
                  gradient="to top, rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.50)"
                  width="210"
                  height="210">
                  <v-icon color="#fff" class="w-100" large>mdi-camera</v-icon>
                </v-img>
              </v-avatar>
            </div>
          </image-input>
        </v-card>
        <div class="d-flex justify-center">
          <v-btn 
            width="100"
            small rounded class="text-capitalize mt-5 mr-3" 
            color="#ff618a"
            :disabled="(selectedPage === 'form' || selectedPage === 'formPassword') && showPage"
            @click="toShowPage('form')">
            <div class=" d-flex align-center white--text">
              <v-icon small left>mdi-pencil-box-outline</v-icon> 
              <div>Ubah</div>
            </div>
          </v-btn>
          <v-btn 
            width="100"
            small rounded class="text-capitalize mt-5"
            color="#ff618a"
            :disabled="(selectedPage === 'form' || selectedPage === 'formPassword') && showPage"
            @click="toShowPage('formPassword')">
            <div class=" d-flex align-center white--text">
              <v-icon small left>mdi-lock</v-icon> 
              <div>
                Password
              </div>
            </div>
          </v-btn>
        </div>
      </v-col>

      <v-col 
        cols="12"
        md="9"
        v-if="!showPage" class="background-default">
        <v-alert 
          v-if="alert"
          type="success">
          Update Password Berhasil
        </v-alert>
        <v-card
          color="transparent"
          tile
          flat>
          <v-list
            color="transparent"
            dense
            subheader
            nav
            avatar>
            <v-subheader class="title">General Profil</v-subheader>
            <v-list-item>
              <v-list-item-avatar tile width="20" height="auto" class="align-self-start justify-start mr-0">
                <v-icon>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="py-1">
                <v-list-item-title class="body-2 text--secondary">
                  {{ user.userFullname }}
                </v-list-item-title>
                <v-list-item-subtitle class="caption font-weight-thin">
                  Nama
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-avatar tile width="20" height="auto" class="align-self-start justify-start mr-0">
              <v-icon>mdi-email</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="py-1">
                <v-list-item-title class="body-2 text--secondary">
                  {{ user.userEmail }}
                </v-list-item-title>
                <v-list-item-subtitle class="caption font-weight-thin">
                  Email
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-avatar tile width="20" height="auto" class="align-self-start justify-start mr-0">
              <v-icon>mdi-cellphone</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="py-1">
                <v-list-item-title class="body-2 text--secondary">
                  {{ user.userPhoneNumber }}
                </v-list-item-title>
                <v-list-item-subtitle class="caption font-weight-thin">
                  Telepon
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <div class="caption px-5 pt-2 pb-2 font-weight-bold">
          Deskripsi
        </div>
        <div class="caption px-5">
          <span
            v-if="user.userDesc.length > 0" 
            v-html="user.userDesc">
          </span>
          <span v-else>
            -
          </span>
        </div>
        <div class="caption px-5 pb-2 font-weight-bold">
          Hak Akses
        </div>
        <div v-if="user.userPrivilege.length > 0">
          <v-list
            color="transparent"
            dense
            nav
            v-for="(item, index) in user.userPrivilege"
            :key="index"
            class="py-0">
            <v-list-item
              :value="true">
              <v-list-item-icon class="mr-3">
                <v-icon>{{ item.menuIcon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.menuTitle }}
                </v-list-item-title>
                <v-list-item-subtitle class="caption font-weight-light font-italic">
                  {{ item.menuUrl }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              :v-if="item.submenuDetail.length > 0"
              v-for="(sub, index) in item.submenuDetail"
              :key="index"
              class="pl-10">
              <v-list-item-icon class="mr-3">
                <v-icon>{{ sub.submenuIcon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ sub.submenuTitle }}
                </v-list-item-title>
                <v-list-item-subtitle class="caption font-weight-light font-italic">
                  {{ sub.submenuUrl }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
        <div 
          class="grey--text text--darken-2 font-weight-bold caption px-5"
          v-if="user.userPrivilege.length < 1">
          Belum tersedia hak akses
        </div>
      </v-col>

      <v-col 
        cols="12"
        md="9"
        v-if="showPage" class="background-default pa-5">
        <div v-if="selectedPage === 'form'">
          <ValidationObserver ref="observer">
            <v-form>
              <ValidationProvider name="Nama" rules="required" v-slot="{ errors }">
                <v-text-field
                  outlined
                  dense
                  color="#fc2d63"
                  label="Nama"
                  v-model="form.profileName"
                  :error-messages="errors"
                  required>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Telepon" rules="required|min:9|max:13" v-slot="{ errors }">
                <v-text-field
                  outlined
                  dense
                  color="#ff618a"
                  label="Telepon"
                  :counter="13"
                  type="number"
                  v-model="form.profileTelephone"
                  :error-messages="errors"
                  required>
                </v-text-field>
              </ValidationProvider>
              <p class="mb-1 mt-3">Deskripsi (optional)</p>
              <quill-editor 
                ref="myTextEditor" 
                v-model="form.profileDesc"
                :options="option">
              </quill-editor>
              <div>
                <v-alert 
                  type="error" 
                  text
                  dense
                  prominent
                  class="mt-3"
                  v-show="response !== ''">
                  {{ response }}
                </v-alert>
              </div>
              <v-card-actions :class="$vuetify.breakpoint.name === 'xs' ? 'mt-3' : 'mt-5'">
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  light
                  :width="$vuetify.breakpoint.name === 'xs' ? '100' : '200'"
                  color="#ff618a"
                  elevation="0"
                  :disabled="process.run"
                  :loading="process.run"
                  @click="save"
                  class="white--text text-capitalize">
                  Simpan
                </v-btn>
                <v-btn
                  rounded
                  outlined
                  light
                  :width="$vuetify.breakpoint.name === 'xs' ? '100' : '200'"
                  elevation="0"
                  :disabled="process.run"
                  class="text-capitalize"
                  @click="showPage=false">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </div>
        <div v-if="selectedPage === 'formPassword'">
          <ValidationObserver ref="observer">
            <v-form>
              <ValidationProvider name="Old Password" rules="required|max:20|min:5" v-slot="{ errors }">
                <v-text-field
                  v-on:keyup.enter="save"
                  class="mt-2 mb-1" 
                  outlined
                  dense 
                  color="#ff618a"
                  placeholder="Password Lama"
                  v-model="form.profilePasswordOld" 
                  :type="showOld ? 'text' : 'password'"
                  :counter="20"
                  :append-icon="showOld ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showOld = !showOld"
                  :error-messages="errors"
                  equired>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="New Password" vid="confirm" rules="required|max:20|min:5" v-slot="{ errors }">
                  <v-text-field
                  v-on:keyup.enter="save"
                  class="mt-2 mb-1"
                  outlined
                  dense 
                  color="#ff618a"
                  placeholder="Password Baru"
                  v-model="form.profilePasswordNew" 
                  :type="showNew ? 'text' : 'password'"
                  :counter="20"
                  :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showNew = !showNew"
                  :error-messages="errors"
                  required>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Confirm New Password" rules="required|max:20|min:5|confirmed:confirm" v-slot="{ errors }">
                <v-text-field
                  v-on:keyup.enter="save"
                  class="mt-2 mb-1" 
                  outlined
                  dense 
                  color="#ff618a"
                  placeholder="Ulangi Password Baru"
                  v-model="form.profilePasswordConfirm" 
                  :type="showConfirm ? 'text' : 'password'"
                  :counter="20"
                  :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showConfirm = !showConfirm"
                  :error-messages="errors"
                  required>
                </v-text-field>
              </ValidationProvider>
              <div>
                <v-alert 
                  type="error" 
                  text
                  dense
                  prominent
                  v-show="response !== ''">
                  {{ response }}
                </v-alert>
              </div>
              <v-card-actions :class="$vuetify.breakpoint.name === 'xs' ? 'mt-2' : ''">
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  light
                  :width="$vuetify.breakpoint.name === 'xs' ? '100' : '200'"
                  color="#ff618a"
                  elevation="0"
                  :disabled="process.run"
                  :loading="process.run"
                  @click="save"
                  class="white--text text-capitalize">
                  Simpan
                </v-btn>
                <v-btn
                  rounded
                  light
                  outlined
                  elevation="0"
                  :width="$vuetify.breakpoint.name === 'xs' ? '100' : '200'"
                  class="text-capitalize"
                  :disabled="process.run"
                  @click="showPage=false">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </div>
      </v-col>
    </v-row>
	</div>
</template>

<script>
  import ImageInput from '../../../components/ImageInput.vue';
  import { TokenService } from "../../../service/Storage.Service";
  import { get, post, put, destroy } from "../../../service/Axios";
	export default {
		data () {
			return {
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Deskripsi . . .'
        },
        alert: false,
        showOld: false,
        showNew:false,
        showConfirm:false,
				showPage: false,
        selectedPage: '',
        items: [
          {
            icon: 'mdi-account',
            text: 'Nama'
          },
          {
            icon: 'mdi-email',
            text: 'Email'
          },
          {
            icon: 'mdi-cellphone',
             text: 'Telepon'
          }
        ],
         icon: [
          {
            icon: 'mdi-apps',
            text: 'Lorem'
          },
          {
            icon: 'mdi-account-multiple',
            text: 'Lorem'
          },
          {
            icon: 'mdi-library',
             text: 'Lorem'
          },
          {
          icon: 'mdi-library-shelves',
           text: 'Lorem'
          },
          {
            icon: 'mdi-library',
             text: 'Lorem'
          },
          {
          icon: 'mdi-library-shelves',
           text: 'Lorem'
          }
        ],
        avatar: null,
				form: {
          profileName: '',
          profileDesc: '',
          profileUrlImage: '',
          profileTelephone:'',
          profilePasswordOld:'',
          profilePasswordNew:'',
          profilePasswordConfirm:''
        },
        process: {
          run: false
        },
        response: ''
			}
    },
    watch:{
      avatar: {
        handler: function () {
          this.form.profileUrlImage = this.avatar.url
        },
        deep: true
      },
    },
    components: {
      ImageInput
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      }
    },
    mounted() {
      this.user.userDesc = this.user.userDesc.replace(/&lt;/g, '<')
    },
		methods: { 
			toShowPage(page) {
        this.selectedPage = page
        this.reset()
				this.showPage =  true
      },
      reset() {
        this.form.profileName= this.user.userFullname,
        this.form.profileDesc= this.user.userDesc,
        this.form.profileUrlImage= this.user.userUrlImg,
        this.form.profileTelephone=this.user.userPhoneNumber
      },
      resetForm() {
        this.form= {
          profileName: '',
          profileDesc: '',
          profileUrlImage: '',
          profileTelephone:'',
          profilePasswordOld:'',
          profilePasswordNew:'',
          profilePasswordConfirm:''
        }
        
        this.showPage = false
      },
			async save() {
				this.response = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          if (this.selectedPage === 'form') {
            this.updateGeneral()
          } else {
            this.updatePassword()
          }
				}
      },
      async updateGeneral() {
        this.process.run = true
        await put(`internal/users/update/${this.user.userId}`, {
          data: {
            name : this.form.profileName,
            desc : this.form.profileDesc,
            phoneNumber: this.form.profileTelephone,
            urlImg : this.form.profileUrlImage,
            role: this.user.userRoles,
            privilege : this.user.userPrivilege
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 201) {
            this.user.userFullname = this.form.profileName,
            this.user.userDesc = this.form.profileDesc,
            this.user.userUrlImg = this.form.profileUrlImage,
            this.user.userPhoneNumber = this.form.profileTelephone
            this.resetForm()
            TokenService.saveToken(this.token, JSON.stringify(res.data))
            this.process.run = false
          } else {
            this.process.run = false
            this.response = res.msg 
          }
        })
      },
      async updatePassword() {
        this.process.run = true
        await put(`internal/users/update/password/${this.user.userId}`, {
          data: {
            password: this.form.profilePasswordOld,
            passwordNew: this.form.profilePasswordNew,
            passwordNewConfirm: this.form.profilePasswordConfirm
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 201) {
            this.alert = true
            this.resetForm()
            this.process.run = false
          } else {
            this.process.run = false
            this.response = res.msg 
          }
        })
      }
		}
	}
</script>

<style scoped>
  .w-100 {
    width: 100%;
  }
</style>